import { useState } from "react";
import { useLogin } from "../hooks/useLogin";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { login, isLoading, error } = useLogin();

  const handelSubmit = async (e) => {
    e.preventDefault();
    const user = { email, password };
    await login(user);
  };
  return (
    <form className="login" onSubmit={handelSubmit}>
      <h3>Login</h3>
      <label>Email: </label>
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <label>Password: </label>
      <input
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <button disabled={isLoading}>Log in</button>
      {isLoading && <div>Loading...</div>}
      {error && <div className="error">{error}</div>}
    </form>
  );
};

export default Login;
